import React from 'react';
import { LuCheck } from 'react-icons/lu';

/**
 * Step progress indicator.
 * Props:
 *   steps - array of { id, name }
 *   currentStep - current step number (1-based)
 */
const StepProgress = ({ steps, currentStep }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <nav aria-label="Progress" className="mb-8 px-4">
      {/* Circles + lines row */}
      <div className="flex items-center">
        {steps.map((stepItem, index) => {
          const isCompleted = currentStep > stepItem.id;
          const isCurrent = currentStep === stepItem.id;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={stepItem.id}>
              {/* Circle */}
              <div className={`flex-shrink-0 flex h-10 w-10 items-center justify-center rounded-full border-2 ${
                isCompleted
                  ? 'border-green-600 bg-green-600 text-white'
                  : isCurrent
                    ? 'border-indigo-600 bg-indigo-600 text-white'
                    : 'border-gray-300 bg-white text-gray-500'
              }`}>
                {isCompleted ? (
                  <LuCheck className="h-5 w-5" />
                ) : (
                  <span className="text-sm font-semibold">{stepItem.id}</span>
                )}
              </div>

              {/* Connector line */}
              {!isLast && (
                <div className={`flex-1 h-0.5 mx-2 ${
                  isCompleted ? 'bg-green-600' : 'bg-gray-200'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Labels row */}
      <div className="flex mt-2">
        {steps.map((stepItem, index) => {
          const isCompleted = currentStep > stepItem.id;
          const isCurrent = currentStep === stepItem.id;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={stepItem.id}>
              {/* Label — positioned relative to the circle, allowed to overflow */}
              <div className="flex-shrink-0 w-10 relative">
                <span className={`absolute left-1/2 -translate-x-1/2 whitespace-nowrap text-xs font-medium text-center leading-tight ${
                  isCompleted
                    ? 'text-green-700'
                    : isCurrent
                      ? 'text-indigo-600'
                      : 'text-gray-500'
                }`}>
                  {stepItem.name}
                </span>
              </div>

              {/* Spacer matching the connector line */}
              {!isLast && <div className="flex-1 mx-2" />}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};

export default StepProgress;
